//  Angular imports
import { Component, inject, input, signal } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationRoute } from 'app/models/application-route';
import { RAccountDetails } from 'app/records/account-details.record';
import { RAccount } from 'app/records/account.record';
import { RHKeyData } from 'app/records/h-key-data.record';
import { RNode, ROrganization } from 'app/records/organization-record';
import { HKeyManagerService } from 'app/services/hkey-manager.service';
import { UserService } from 'app/services/user.service';
import { NgIf, NgClass, NgFor } from '@angular/common';
import { LoadingIndicatorComponent } from '../loading-indicator/loading-indicator.component';
import { HoverClassDirective } from '../../directives/hover-over.directive';

@Component({
    selector: 'zf-org-chooser',
    templateUrl: './org-chooser.component.html',
    styleUrls: ['./org-chooser.component.scss'],
    imports: [NgIf, LoadingIndicatorComponent, NgClass, NgFor, HoverClassDirective]
})
export class OrgChooserComponent {
    private router = inject(Router);
    private userService = inject(UserService);
    private hKeyManagerService = inject(HKeyManagerService);

    public readonly orgNodes = input<Array<ROrganization>>();
    public readonly withTitle = input<boolean>(true);
    public readonly withSearch = input<boolean>(true);
    public readonly isLarge = input<boolean>(false);

    public readonly isLoading = signal<boolean>(false);

    public selectNode(node: RNode) {
        if (!this.isLoading() && node.isSelectable) {
            this.isLoading.set(true);
            this.userService.getOrgPermissions(node.nodeId)
                .subscribe((account: RAccount) => {
                    account.details.selectedNode = node;
                    this.setSelectedAccount(account);
                });
        }
    }

    public collapse(nodeId: number, index: number, toggle: boolean): void {
        for (const org of this.orgNodes()) {
            this.collapseNode(org.nodes, nodeId, index, toggle);
        }
    }

    private completeAndStore(account: RAccountDetails): void {
        this.hKeyManagerService.delete();
        const hKeyDataPartial: Partial<RHKeyData> = RHKeyData.partialFromAccount(account);
        const storedHKey: RHKeyData = this.hKeyManagerService.get();
        const hKeyData: RHKeyData = RHKeyData.complete(hKeyDataPartial, storedHKey);
        this.hKeyManagerService.store(hKeyData);
    }

    private setSelectedAccount(account: RAccount): void {
        this.completeAndStore(account.details);
        this.userService.selectAccount(account);
        this.router.navigateByUrl(ApplicationRoute.ENTITLEMENTS).then((): void => { this.isLoading.set(false); });
    }

    private collapseNode(nodes: Array<RNode>, nodeId: number, index: number, toggle: boolean): void {
        for (let idx = index; idx < nodes.length; idx++) {
            const element = nodes[idx];

            if ((element.type === 0 || element.type === 1) && element.parentId == nodeId && !element.selected) {
                // root and ou node -- can be selected
                element.show = toggle;
                this.collapseNode(nodes, element.nodeId, idx + 1, toggle);
            } else if (element.parentId == nodeId) {
                // children
                element.show = toggle;
            }
        }
    }

}
